const variables = {
  SPACE_UNIT: 10,
};

export default variables;
